import axios from "axios";
import authHeader from "./auth-header";
import IPurchase from "../types/purchase.type";
import {toFormData} from "./utils.axios";
import IPurchaseApprovalChangeStatus from "../types/purchase-approval-change-status.type";


const API_URL = `${process.env.REACT_APP_SERVER_URL}/purchase`;

export const getById = (id: any) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (purchase: IPurchase) => {
  const headers = authHeader();
  headers['Content-Type'] = 'multipart/form-data';
  const { statusHistory: _omit, ...payload } = purchase;
  const formData = toFormData(payload);
  return axios.post(API_URL, formData, { headers: headers });
};

export const update = (id: number, purchase: IPurchase) => {
  const headers = authHeader();
  headers['Content-Type'] = 'multipart/form-data';
  const { statusHistory: _omit, ...payload } = purchase;
  const formData = toFormData(payload);
  return axios.put(API_URL + "/" + id, formData, { headers: headers });
};

export const changeStatus = (id: number, status: IPurchaseApprovalChangeStatus) => {
  return axios.put(API_URL + "/" + id + "/change-status", status, { headers: authHeader() });
};

export const deleteById = (id: any) => {
  return axios.delete(API_URL + "/" + id, { headers: authHeader() });
};

export const getPurchases = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const exportPurchases = async (params: {}) => {
  const response = await axios.get(`${API_URL}/export`, {
    params: params,
    headers: authHeader(),
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];
  const fileNameMatch = contentDisposition?.match(/filename="?([^"]+)"?/);
  const fileName = fileNameMatch?.[1] ?? "compras.xlsx";

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(url);
};
